<template>
    <div style="position: relative">
      <div class="close" @click="SayHiFlag">{{ sayHiFlag?'CLOSE':'OPEN' }}</div>
      <div class="contact_block bg-color" v-if="sayHiFlag">
            <div class="footer-contact">
                <div class="contact_left">
                    <img src="../../assets/image/components/sayHi.png" class="contact_left_image"/>
                    <div class="contact_left_text">Copyright 2021 VTL All Rights Reserved.</div>
                </div>
                <div class="contact_middle">
                    <div class="contact_middle_title">E-MAIL ADDRESS:</div>
                    <div class="contact_middle_email">business@averymedia.us</div>
                </div>
                <div class="contact_right">
                    <img src="../../assets/image/components/tv.png" class="contact_right_image"/>
                </div>
            </div>
        </div>
        <div class="footer_block">
            <div class="footer_left">
                <img src="../../assets/image/components/footerText.png" class="footer_left_image" />
                <div class="footer_left_button" @click="toPage(2)">GET IN TOUCH</div>
            </div>
            <div class="footer_right">
                <img src="../../assets/image/components/footerLogo.png" @click="toPage(3)" class="footer_right_logo" />
                <div class="footer_right_page">
                    <div class="page_name" @click="toPage(0)">ABOUT US</div>
                    <div class="page_name" @click="toPage(1)" style="margin: 22px 0;">TRADE UNION</div>
                    <div class="page_name" @click="toPage(2)">CONTACT US</div>
                </div>
                <div class="footer_right_image">
                    <img src="../../assets/image/components/tiktok.png"/>
                    <img src="../../assets/image/components/ins.png"/>
                    <img src="../../assets/image/components/facebook.png"/>
                    <img src="../../assets/image/components/youtube.png"/>
                    <img src="../../assets/image/components/twitter.png"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref,reactive } from "vue";
import { useRouter } from 'vue-router'
const route = useRouter()
const sayHiFlag = ref(true)


const path = reactive([
  '/about_us',
  '/trade_union',
  '/contact_us',
  '/avery_media'
])

const toPage = (index)=>{
  route.push(path[index])
}

const SayHiFlag = ()=> {
  sayHiFlag.value = !sayHiFlag.value
}
</script>

<style lang="scss" scoped>
.contact_block {
    width: 100%;
    height: 258px;
    position: relative;
    z-index: 111;
    .footer-contact{
        width: 1920px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 0 auto;
        position: relative;
        .contact_left{
            margin-left: 66px;
            .contact_left_image{
                width: 236px;
                height: 130px;
                margin-top: -24px;
                margin-bottom: 24px;
            }
            .contact_left_text{
                line-height: 14px;
                font: {
                    size: 14px;
                    weight: 400;
                    family: Montserrat-Regular;
                };
            }
        }
        .contact_middle {
            flex: 1;
            padding-left: 152px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            .contact_middle_title {
                line-height: 24px;
                font: {
                    size: 24px;
                    weight: bold;
                    family: Montserrat-Bold;
                };
            }
            .contact_middle_email {
                line-height: 36px;
                margin-top: 24px;
                font: {
                    size: 36px;
                    weight: bold;
                    family: Montserrat-Bold;
                };
            }
        }
        .contact_right {
            padding-right: 114px;
            .contact_right_image {
                width: 184px;
                height: 178px;
            }
        }

    }
}
.footer_block {
    width: 1920px;
    height: 330px;
    margin: 0 auto;
    background-color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .footer_left {
        margin-left: 344px;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        .footer_left_image {
            width: 700px;
            height: 162px;
            margin-bottom: 44px;
        }
        .footer_left_button {
            width: 216px;
            height: 44px;
            background: #03FF7B;
            border-radius: 24px;
            border: 2px solid #000000;
            display: flex;
            justify-content: center;
            align-items: center;
            line-height: 14px;
            margin-right: -62px;
            cursor: pointer;
            font: {
                size: 14px;
                weight: bold;
                family: Montserrat-Bold;
            };
        }
    }
    .footer_right {
        margin-right: 360px;
        .footer_right_logo {
            width: 186px;
            height: 32px;
            cursor: pointer;
        }
        .footer_right_page {
            padding-left: 46px;
            margin-top: 14px;
            margin-bottom: 54px;
            cursor: pointer;
            .page_name {
                line-height: 14px;
                color: #636363;
                font: {
                    size: 14px;
                    weight: 400;
                    family: Montserrat-Regular;
                };
            }
        }
        .footer_right_image {
            img {
                width: 30px;
                height: 30px;
                margin-right: 14px;
            }
        }
    }
}
.close {
  width: 94px;
  height: 94px;
  border-radius: 50%;
  background-color: #FFFFFF;
  position: absolute;
  top: -60px;
  right: 130px;
  line-height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: rotate(20deg);
  cursor: pointer;
  z-index: 112;
  box-shadow: 0px 3px 20px 1px rgba(0,0,0,0.16);
  font: {
    size: 20px;
    weight: bold;
    family: Montserrat-Bold;
  };
}
</style>